/* eslint-disable jsx-a11y/anchor-is-valid */

/* eslint-disable react/jsx-no-target-blank */
import { SvgIcon, Text, TextStyles } from '@cinch-labs/design-system'
import Wrapper from '@cinch-nx/shared-ui/lib/wrapper/wrapper'
import Link from 'next/link'

import { JargonContent, KeywordList, RelatedJargon } from './components'
import styles from './jargon.module.css'
import { JargonFeatureProps } from './types'
import { isJargonHubStoryContent } from './utils/is-jargon-hub-story-content'

const siteUrl = 'https://www.cinch.co.uk/'

export const JargonFeature: React.FC<JargonFeatureProps> = ({
  content,
  rels,
  slug,
}) => {
  if (isJargonHubStoryContent(content)) {
    const { fullTerm, term, question, answer, image, keywords } = content

    const reducedRelatedJargon = rels?.map((p) => ({
      slug: p.slug ?? '',

      content: {
        summary: p.content?.summary ?? '',
        question: p.content?.question ?? '',
        keywords: p.content?.keywords ?? '',
        fullTerm: p.content?.fullTerm ?? '',
      },
    }))
    const keywordList = keywords?.split(',').map((p) => p.trim())
    return (
      <article className={styles.page}>
        <Wrapper>
          <div className={styles.header}>
            <Link href={'/jargon'} passHref>
              <a className={styles.headerLink}>
                <SvgIcon name="chevron-left" height={12} color="toreaBay" />
                All Jargon
              </a>
            </Link>
            <Link
              href={`mailto:?subject=${question} - Cinch&body=${siteUrl}/jargon/${slug}`}
              passHref
            >
              <a target="_blank" className={styles.headerLink}>
                <SvgIcon name="share" height={16} gradient="newGalaxy" />
                Share by Email
              </a>
            </Link>
          </div>
          <h1 className={styles.fullTerm}>
            {fullTerm}
            {term && ` (${term})`}
          </h1>
          {keywordList && keywordList.length > 0 && (
            <KeywordList items={keywordList} />
          )}

          <JargonContent question={question} answer={answer} image={image} />
          {rels && rels.length > 0 && reducedRelatedJargon && (
            <>
              <div className={styles.title}>
                <Text
                  element="h2"
                  type={TextStyles.mainTitle}
                  lineHeight="display"
                >
                  Related Jargon
                </Text>
              </div>
              <RelatedJargon items={reducedRelatedJargon} />
            </>
          )}
        </Wrapper>
      </article>
    )
  } else {
    return null
  }
}
